<template>
  <div class="aboutUs">
    <sectionTitle :titleObj="titleObj"></sectionTitle>
    <div class="content">
      <div class="menu">
        <router-link :to="{ path: item.path }" class="menu-item flex-center" :class="{'menu-item-select':isActive(item.path)}" v-for="item in menu" :key="item.name">{{item.name}}</router-link>
      </div>
      <div style="flex:1">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import sectionTitle from '@/components/sectionTitle.vue'

export default {
  components:{
    sectionTitle
  },
  data(){
    return {
      titleObj:{
        title:'资源中心',
        subtitle:'RESOURCE CENTRE'
      },
      menuSelectName:'政策法规',
      menu:[
        {
          name:'政策法规',
          path:'/resourceCenter/policyRegulations'
        },
        {
          name:'各类表格',
          path:'/resourceCenter/variousForms'
        },
        {
          name:'参观预约表格',
          path:'/resourceCenter/visitForms'
        }
      ]
    }
  },
  methods:{
    isActive(path){
      return this.$route.path === path
    }
  }
}
</script>

<style lang="less" scoped>
.aboutUs{
  padding:0 10%;
  padding-bottom: 109px;
}
.content{
  gap:64px;
  display: flex;
  .menu{
    display: flex;
    flex-direction: column;
    gap:8px;
    .menu-item{
      width: 257px;
      height: 64px;
      background: #f3f1ef;
      cursor: pointer;
      font-size: 20px;
      color:#333333;
    }
    .menu-item-select{
      background: #ed9d26;
      color:#FFFFFF;
    }
  }
  .title{
    font-size: 36px;
    color: #333333;
    font-weight: bold;
    text-align: center;
    margin-bottom: 32px;
  }
  .introduce{
    font-size: 20px;
    color: #333333;
    line-height: 48px;
  }
}


</style>